const TeamMateCard = (props) => {
  return (
    <div className="col-12 col-md-6 col-xl-3">
        <div className="revamp-team-card">
            <div
                className="member-img"
                style={{
                    backgroundImage: `url('${props.bgImgUrl}')`,
                    backgroundPosition: props.imagePosition || "center",
                }}
            >
            </div>
            <div className="member-bio">
                <h4>{props.name}</h4>
                <p>{props.role}</p>
            </div>
        </div>
    </div>
  );
};

export default TeamMateCard;
